import { render, staticRenderFns } from "./button-bubble.vue?vue&type=template&id=f6bd84fe&scoped=true&"
var script = {}
import style0 from "./button-bubble.vue?vue&type=style&index=0&id=f6bd84fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6bd84fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6bd84fe')) {
      api.createRecord('f6bd84fe', component.options)
    } else {
      api.reload('f6bd84fe', component.options)
    }
    module.hot.accept("./button-bubble.vue?vue&type=template&id=f6bd84fe&scoped=true&", function () {
      api.rerender('f6bd84fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/cssfx/components/button-bubble.vue"
export default component.exports